import React, { useState } from "react";
import { Link } from "react-router-dom";

const FilterComponent = (props) => {
  const { filterButtons } = props;
  const values = filterButtons.map((filter) => {
    return filter.label;
  });
  return (
    <div>
      <form name="myform" className="form">
        <div className="optionsDiv" style={{ width: "100%" }}>
          {filterButtons.map((filter, ind) => {
            return (
              <>
                <input
                  type="radio"
                  id={values[ind]}
                  className="optionBtn"
                  name={"radioButton"}
                  value={values[ind]}
                  checked={props.filterValue == values[ind]}
                  onChange={(e) => {
                    props.setfilterValue(values[ind]);
                    props.setProfiles([]);
                    props.setRequest({
                      ...props.request,
                      from: 0,
                      filter: filter.value,
                    });
                    props.setStopInfiniteScroll(false);
                  }}
                />
                <label className={"optionLabel"} for={filter.label}>
                  {filter.label}
                </label>
              </>
            );
          })}
        </div>{" "}
      </form>
    </div>
  );
};

export default FilterComponent;
